/**
 * "Eigenaar controleren" — de bekende eigenaar van een dier op een kaart, met de vraag of die klopt
 * en een Ja/Nee-paar. Gedeeld door de inboek-wizard (afstand / retour na plaatsing) en de
 * uitboek-wizard (plaatsing), zodat dezelfde vraag er in beide wizards hetzelfde uitziet.
 *
 * Bewust géén standaardkeuze: zolang er niets is aangeklikt blijft de stap op slot en zegt de regel
 * eronder waarom. Een dier bij de verkeerde eigenaar boeken is niet iets wat stilzwijgend mag gebeuren.
 */

/** De eigenaar zoals de api hem oplost (GET …/reference/animals/{id}/known-owner). */
export interface KnownOwnerView {
  animalId?: number;
  ownerId: number | null;
  ownerLabel: string | null;
  addressLine: string | null;
  postcodeCity: string | null;
  phone: string | null;
  email: string | null;
}

export function OwnerConfirmCard({
  owner,
  choice,
  onYes,
  onNo,
  question,
  yesLabel,
  noLabel,
  t,
}: {
  owner: KnownOwnerView;
  /** null = nog niet beantwoord; de stap hoort dan geblokkeerd te zijn. */
  choice: "yes" | "no" | null;
  onYes: () => void;
  onNo: () => void;
  /** De vraag boven de kaart — per flow anders ("die afstand doet?" / "bij deze eigenaar geplaatst?"). */
  question: string;
  yesLabel: string;
  noLabel: string;
  t: (k: string) => string;
}) {
  return (
    <>
      <span className="fawkes-inboeken__helper">{question}</span>
      <div className="fawkes-inboeken__newanimal fawkes-inboeken__owner-card">
        <span className="fui-field__label">{t("inboeken.ownerConfirm.ownerTitle")}</span>
        <strong>{owner.ownerLabel ?? "-"}</strong>
        {owner.addressLine && <span>{owner.addressLine}</span>}
        {owner.postcodeCity && <span>{owner.postcodeCity}</span>}
        {(owner.phone || owner.email) && (
          <span className="fui-field__label">{t("inboeken.ownerConfirm.contactTitle")}</span>
        )}
        {owner.phone && <span>{owner.phone}</span>}
        {owner.email && <span>{owner.email}</span>}
      </div>
      <div className="fawkes-inboeken__choice">
        <button type="button" className={choice === "yes" ? "is-selected" : ""} onClick={onYes}>
          {yesLabel}
        </button>
        <button type="button" className={choice === "no" ? "is-selected" : ""} onClick={onNo}>
          {noLabel}
        </button>
      </div>
      {choice === null && (
        <span className="fawkes-inboeken__field-error">{t("inboeken.ownerConfirm.required")}</span>
      )}
    </>
  );
}
